import { APIMethod, fetchData } from "@client";

export async function applyCouponQuery(code) {
  return await fetchData("/company/coupon", APIMethod.POST, { data: { code } });
}
